import { render, staticRenderFns } from "./PublicPopUp.vue?vue&type=template&id=65992cc7&scoped=true"
import script from "./PublicPopUp.vue?vue&type=script&lang=js"
export * from "./PublicPopUp.vue?vue&type=script&lang=js"
import style0 from "./PublicPopUp.vue?vue&type=style&index=0&id=65992cc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65992cc7",
  null
  
)

export default component.exports